

export default {
   data() {
      return {
         // dialog_show_error: false,
         // show_error_obj: null,

      };
   },


   methods: {


      /**
       * Simple helper function to get index of an object in an array based on a given property
       *
       * @param array - an array of objects
       * @param attr - str, name of proprty to search for
       * @param value - value to search for

       * @returns index of item or -1 if not found
       *
       * ref: https://stackoverflow.com/questions/7176908/how-to-get-index-of-object-by-its-property-in-javascript/54015295
       */

      findWithAttr(array, attr, value) {

         // console.log('array', array)
         for(let i = 0; i < array.length; i += 1) {
            let a = attr.split('.');
            let val;
            val = array[i][a[0]];


            // console.log('a', a)
            for (let j=1; j < a.length; j++) {

               val = val[a[j]];
            }

            // console.log('val', val, 'value', value)
            if(val === value) {
               return i;
            }
         }
         return -1;
      },


      sort_bib_list(list) {

         for (let i = 0; i < list.length; i++) {

            if (list[i].raw !== '' && list[i].raw != null) {
               list[i].sort_ix = list[i].raw;

            } else if (list[i].title !== '' && list[i].title != null) {
               list[i].sort_ix = list[i].title;

            } else if (list[i].url !== '' && list[i].url != null) {
               list[i].sort_ix = list[i].url;
            }
         }

         list.sort((a, b) => (a.sort_ix > b.sort_ix) ? 1 : -1);
         return list;

      }
   }, // methods

}; // export


